import { Constants } from "./constants";

export class PageTemplate {
    public contentDocId: String = '';
    public thumbUrl:String ='';
    public name: String = '';
    public type: String = 'pageTemplate';
    public _id: String = '';
    public owner: String = Constants.USER;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/pageTemplate.ts